module.exports = __webpack_public_path__ + "static/web-dev-524295b8babceacc74cae2d66ce17b35.jpg";